import styles from "./ConsentModal.module.scss";

function ConsentModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <button
          className={styles.closeBtn}
          onClick={onClose}
          aria-label="Fermer"
        >
          ×
        </button>
        <h2>Utilisation de vos données</h2>
        <p>
          Les informations que vous renseignez dans ce formulaire sont
          enregistrées par la société <strong>Eclat de beauté</strong>,
          responsable du traitement, pour :
        </p>
        <ul>
          <li>
            - la gestion de votre rendez-vous (prise, confirmation, suivi) ;
          </li>
          <li>- la gestion administrative de la relation client ;</li>
          <li>- l'établissement de statistiques internes sur l'activité.</li>
        </ul>
        <p>
          Ces données sont conservées pendant 3 ans après le dernier rendez-vous
          et ne sont transmises à aucun tiers à des fins commerciales.
        </p>
        <p>
          Conformément au RGPD, vous disposez d'un droit d'accès, de
          rectification, d'effacement et d'opposition, à exercer auprès de{" "}
          <a href="mailto:contact@éclatdebeauté.fr">contact@éclatdebeauté.fr</a>
          .
        </p>
        <p>
          Pour le détail complet, consultez notre{" "}
          <a href="/legal" target="_blank" rel="noopener noreferrer">
            politique de confidentialité
          </a>
          .
        </p>
      </div>
    </div>
  );
}

export default ConsentModal;
